exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Timeline .loadmore-text{opacity:1}.Timeline.-blocked{cursor:progress}.timeline-heading{max-width:100%;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.timeline-heading .loadmore-button,.timeline-heading .loadmore-text{-ms-flex-negative:0;flex-shrink:0}.timeline-heading .loadmore-text{line-height:1em}", ""]);

// exports
